var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":require("../../assets/no-data.png"),"alt":""}}),_c('p',{staticClass:"no-data-text"},[_vm._t("text"),_c('span',{on:{"click":_vm.goPage}},[_vm._t("textAct")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }